<div class="insights-page">
  @if (user()) {
  <div class="insights-shell w-100">
    <header class="insights-hero">
      <div class="insights-hero-copy">
        <h1>Profile</h1>
        <p class="insights-lead">Your account details and personal information.</p>
      </div>
    </header>

    <section class="profile-section">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center gap-4">
          <div class="profile-picture rounded-circle position-relative">
            @if (user().profilePictureUrl) {
            <img
              [src]="user().profilePictureUrl"
              alt="Profile Picture"
              class="rounded-circle"
            />
            } @else {
            <span class="member-avatar rounded-circle" aria-hidden="true">
              <span>{{ userInitials() }}</span>
            </span>
            }
            <input
              type="file"
              accept="image/*"
              hidden
              (change)="onProfilePictureSelected($event)"
            />
            <i
              class="bi bi-camera-fill camera-icon"
              (click)="onUploadProfilePicture()"
            >
            </i>
          </div>
          <div>
            <div class="fw-bold user-name">
              {{ user().name }} {{ user().surname }}
            </div>
            <div>{{ user().email }}</div>
          </div>
        </div>
        <div class="text-end">
          <div class="fw-500">{{ projects().length }} projects</div>
        </div>
      </div>
    </section>
    <section class="profile-section">
      <div class="d-flex align-items-center justify-content-between">
        <h2 class="section-title">Personal Information</h2>
        @if (!editing()) {
        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn btn-primary d-flex align-items-center gap-2"
            (click)="openChangePasswordModal()"
          >
            Change password
            <i class="bi bi-shield-lock"></i>
          </button>
          <button
            type="button"
            class="btn btn-primary d-flex align-items-center gap-2"
            (click)="toggleEditing()"
          >
            Edit
            <i class="bi bi-pencil"></i>
          </button>
        </div>
        } @else {
        <div class="d-flex gap-2">
          <button class="btn btn-light" type="button" (click)="toggleEditing()">
            Cancel
          </button>
          <button
            class="btn btn-primary d-inline-flex align-items-center gap-2"
            type="button"
            [disabled]="saving()"
            (click)="updateUser()"
          >
            @if (!saving()) { Save } @else {
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <span>Saving...</span>
            }
          </button>
        </div>
        }
      </div>
      <hr />
      <div class="d-grid">
        <div class="row mb-4">
          <div class="col-md-4">
            <div class="text-muted fw-light">First Name</div>
            @if (!editing()) {
            <div class="fw-500">{{ user().name }}</div>
            } @else {
            <input
              class="form-control"
              [ngModel]="name()"
              (ngModelChange)="name.set($event)"
              placeholder="First name"
            />
            }
          </div>
          <div class="col-md-4">
            <div class="text-muted fw-light">Last Name</div>
            @if (!editing()) {
            <div class="fw-500">{{ user().surname }}</div>
            } @else {
            <input
              class="form-control"
              [ngModel]="surname()"
              (ngModelChange)="surname.set($event)"
              placeholder="Last name"
            />
            }
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="text-muted fw-light">Email</div>
            <div class="fw-500">{{ user().email }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
  }
</div>
